import React from "react";
import styled from "styled-components";
import { ProjectContainer, ProjectTitle, ProjectInfo } from "./styles";
import { useLanguage } from "../../contexts/LanguageContext";

const ProjectDescription = styled.div`
  margin-bottom: 30px;
  line-height: 24px;
`;

const ProjectWrapper = styled.div`
  margin-bottom: 40px;

  h4 {
    font-size: 20px;
    color: #333;
    margin: 0 0 20px 0;
    font-weight: 600;
  }

  img {
    width: 100%;
    max-width: 600px;
    height: auto;
    margin-bottom: 20px;
    border: 1px solid #eee;
  }

  ul.list-inline {
    list-style: none;
    padding: 0;
    display: flex;
    gap: 20px;
    flex-wrap: wrap;

    li {
      b {
        color: #333;
      }
    }
  }

  .closeBtn {
    text-align: center;
    margin-top: 30px;

    .btn {
      background: #007bff;
      color: #fff;
      border: none;
      padding: 12px 25px;
      border-radius: 3px;
      cursor: pointer;
      font-weight: 600;
      transition: all 0.3s;

      &:hover {
        background: #0056b3;
      }

      i {
        margin-right: 8px;
      }
    }
  }
`;

interface ProjectD3Props {}

const ProjectD3: React.FC<ProjectD3Props> = () => {
  const { t } = useLanguage();

  return (
    <ProjectContainer>
      <ProjectTitle>
        <h2>{t("d3.title")}</h2>
        <p className="tags">{t("d3.role")}</p>
      </ProjectTitle>

      <ProjectDescription>{t("d3.description")}</ProjectDescription>

      <ProjectInfo>
        <p>
          <b>{t("d3.roleLabel")}</b> {t("d3.myRole")}
        </p>
        <p>
          <b>{t("d3.skillsLabel")}</b> {t("d3.skillsUtilized")}
        </p>
      </ProjectInfo>

      <ProjectWrapper>
        <h4>{t("d3.project1Title")}</h4>

        <img loading="lazy" decoding="async"
          src="/images/portfolio/p7-d3-min.webp"
          className="img-responsive"
          alt="d3-p1"
        />

        <ul className="list-inline">
          <li>
            <b>{t("d3.dateLabel")}</b> {t("d3.project1Date")}
          </li>
          <li>
            <b>{t("d3.teamMembersLabel")}</b> {t("d3.project1Team")}
          </li>
        </ul>
      </ProjectWrapper>

      <ProjectWrapper>
        <h4>{t("d3.project2Title")}</h4>
        <img loading="lazy" decoding="async"
          src="/images/portfolio/p2-1-min.webp"
          className="img-responsive"
          alt="d3-p2"
        />
        <img loading="lazy" decoding="async"
          src="/images/portfolio/p2-2-min.webp"
          className="img-responsive"
          alt="d3-p2"
        />

        <ul className="list-inline">
          <li>
            <b>{t("d3.dateLabel")}</b> {t("d3.project2Date")}
          </li>
          <li>
            <b>{t("d3.teamMembersLabel")}</b> {t("d3.project2Team")}
          </li>
        </ul>
      </ProjectWrapper>

      <ProjectWrapper>
        <h4>{t("d3.project3Title")}</h4>
        <img loading="lazy" decoding="async"
          src="/images/projects/d3-mobile-min.webp"
          className="img-responsive"
          alt="d3-p3"
        />

        <ul className="list-inline">
          <li>
            <b>{t("d3.dateLabel")}</b> {t("d3.project3Date")}
          </li>
          <li>
            <b>{t("d3.teamMembersLabel")}</b> {t("d3.project3Team")}
          </li>
        </ul>
      </ProjectWrapper>

      <ProjectWrapper>
        <h4>{t("d3.project4Title")}</h4>
        <p>{t("d3.selectRoute")}</p>
        <img loading="lazy" decoding="async"
          src="/images/projects/d3-choose-routes.gif"
          className="img-responsive"
          alt="d3-p3"
        />
        <p>{t("d3.hoverDetail")}</p>
        <img loading="lazy" decoding="async"
          src="/images/projects/d3-hover-detail.gif"
          className="img-responsive"
          alt="d3-p3"
        />
      </ProjectWrapper>
    </ProjectContainer>
  );
};

export default ProjectD3;
